<template>
  <SlideXLeftTransition>
    <div class="location-wrap"
         v-show="isOpen" v-if="marker.location !== undefined">
      <div class="location-thumbnail">

        <!-- Location thumbnail -->
        <div class="location-thumbnail__image">
          <img v-bind:src="marker.thumbnail" alt=""/>
        </div>
        <div class="location-thumbnail__info">

          <!-- Partner logo -->
          <div
            class="location-thumbnail__partner"
            v-if="marker.waterPointType === 'Partner'"
          >
            <img
              class="partner-icon"
              src="@/assets/icons/partner-uff.svg"
              alt=""
            />
          </div>

          <!-- Location title -->
          <div class="location-title-wrap">

            <span class="location-title" v-html="marker.title"></span>

            <!-- Location subtitle -->
            <!-- Partner category -->
            <span
              class="location-category"
              v-if="
              marker.category && marker.waterPointType === 'Partner'
            "
              v-text="marker.category"
            ></span>

            <!-- Public fountain -->
            <span
              class="location-category"
              v-if="marker.category === 'Fontana pubblica'"
            >
            {{ $t('public-water') }}
            </span>

            <!-- Refill now shop -->
            <span
              class="location-category"
              v-if="marker.waterPointType === 'Punto Di Acquisto'"
            >
            {{ $t('refill-now-shop') }}
            </span>
          </div>

          <!-- Extra info icons -->
          <div class="location-extra-info">

            <!-- Water type -->
            <div v-if="marker.waterPointType !== 'Punto Di Acquisto'">
            <span
              class="location-water-type icon"
              :class="'icon--' + lowerCase(marker.waterType)"
              v-if="marker.waterType === 'Acqua pubblica'"
            >
            {{ $t('tap-water') }}
            </span>
              <span
                class="location-water-type icon"
                :class="'icon--' + lowerCase(marker.waterType)"
                v-if="marker.waterType === 'Acqua filtrata'"
              >
              {{ $t('filtered-water') }}
              </span>
              <span
                class="location-water-type icon"
                :class="'icon--' + lowerCase(marker.waterType)"
                v-if="marker.waterType === 'Acqua sorgiva'"
              >
              {{ $t('spring-water') }}
              </span>
              <span
                class="location-water-type icon"
                :class="'icon--' + lowerCase(marker.waterType)"
                v-if="marker.waterType === 'Acqua dispenser'"
              >
              {{ $t('water-dispenser') }}
              </span>

              <!-- Fee -->
              <span
                class="location-water-fee icon"
                :class="'icon--' + lowerCase(marker.fee)"
                v-if="marker.fee === 'Acqua gratuita'"
              >
              {{ $t('free-water') }}
              </span>
              <span
                class="location-water-fee icon"
                :class="'icon--' + lowerCase(marker.fee)"
                v-if="marker.fee === 'Acqua a pagamento'"
              >
            {{ $t('paid-water') }}
              </span>
            </div>
            <!-- Walking distance -->
            <span
              class="location-walking-distance icon icon--walkingdistance"
              v-if="walkingDistance.length"
              v-text="walkingDistance"
            ></span>
          </div>
        </div>

        <div class="buttons">
          <a class="location-thumbnail__button" @click="showDetails()">
            {{ $t('location-details') }}
          </a>
          <a
            class="location-thumbnail__button gtm-directions"
            :id="marker.title"
            :href="`https://www.google.com/maps/dir/?api=1&&destination=${marker.location.lat},${marker.location.lng}`"
          >
            {{ $t('google-maps') }}
          </a>
        </div>
      </div>
    </div>
  </SlideXLeftTransition>
</template>

<script>
import { SlideXLeftTransition } from 'vue2-transitions'

export default {
  components: {
    SlideXLeftTransition
  },
  name: 'LocationThumbnail',
  props: {
    walkingDistance: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    marker: {
      type: Object
    }
  },
  methods: {
    showDetails () {
      this.$emit('showDetails')
    },
    lowerCase (string) {
      return string.toLowerCase().replace(/\s/g, '')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
span.icon {
  display: flex;
  margin-bottom: 5px;
  color: $blue-dark;
  align-items: center;

  &::before {
    content: "";
    width: 30px;
    height: 30px;
    margin-right: 10px;
    display: inline-flex;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 80% 80%;
  }

  &--acquadispenser::before {
    background-image: url(~@/assets/icons/icon-dispenser.svg);
  }

  &--acquapubblica::before {
    background-image: url(~@/assets/icons/icon-publica.svg);
  }

  &--acquagratuita::before {
    background-image: url(~@/assets/icons/icon-gratuita.svg);
  }

  &--acquafiltrata::before {
    background-image: url(~@/assets/icons/icon-filtrata.svg);
  }

  &--acquasorgiva::before {
    background-image: url(~@/assets/icons/icon-sorgiva.svg);
  }

  &--acquaapagamento::before {
    background-image: url(~@/assets/icons/icon-pagamento.svg);
  }

  &--walkingdistance::before {
    background-image: url(~@/assets/icons/walking-dark.svg);
  }
}

.location-title {
  font-weight: bold;
  font-size: 20px;
  margin: 0;
  line-height: 1.2;
  margin-bottom: 5px;
  display: block;
}

.location-category {
  margin-bottom: 20px;
  display: block;
}

.location-walking-distance {
  margin-bottom: 10px;
}

.location-thumbnail {
  width: 95vw;
  max-width: 420px;
  background: white;
  display: flex;
  flex-wrap: wrap;
  border-radius: 13px;
  padding: 10px;
  align-content: flex-start;
  margin: auto 10px 10px 10px;
  position: absolute;
  bottom: 5px;
  z-index: 9000;
  color: $blue-dark;

  &__image {
    flex: 1;
    margin-right: 2%;

    img {
      width: 100%;
    }
  }

  &__info {
    display: block;
    flex: 1;
    margin-left: 2%;
    position: relative;
  }

  &__button {
    background: #293171;
    color: white;
    padding: 10px;
    text-align: center;
    border-radius: 6px;
    margin-top: 10px;
    cursor: pointer;
    width: 48%;
  }

  &__partner {
    position: absolute;
    top: -7px;
    right: 4px;
    width: 20px;
    height: 20px;
  }

  .buttons {
    flex: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>
